import { debounce } from './resizeHandler.js';

jQuery(document).ready(function() {
    'use strict';

    // Only run this code if we're on the experts listing page
    if (jQuery('#experts-filter-form').length) {
        /*************************************
         * CONFIGURATION & CACHED ELEMENTS
         *************************************/
        // Filters and search
        const $expertsListingContainer = jQuery(".experts-listing");
        const $expertsSearchKeyword = jQuery(".experts-listing--filters #keyword");
        const $expertsFilterPractices = jQuery('.experts-listing--filters #practices-panel');
        const $expertsFilterSectors = jQuery('.experts-listing--filters #sectors-panel');
        const $expertsFilterGlobalNetworks = jQuery('.experts-listing--filters #global_networks-panel');
        const $parentCheckbox = jQuery('.filter-input .parent-term input[type="checkbox"]');
        const $childrenCheckbox = jQuery('.filter-input .child-terms input[type="checkbox"]');
        const $searchFormSubmit = jQuery("#experts-filter-form");
        const $submitButton = jQuery("#experts-filter-form .submit");
        const $ajaxLoader = jQuery('.ajax-loader');
        const $expertsList = jQuery('.experts-listing--items');
        const $pagination = jQuery('.experts-listing .pagination');
        const $sortContainer = jQuery('.filter-input.sort');
        const $sortLink = jQuery('.sort-link');
        const $actions = jQuery('#actions');
        const $filterSelections = jQuery('.filter-selections');
        const $clearSelectionsLink = jQuery('.clear-selection');
        const $clearLink = jQuery(".reset-link");
        const $postCount = jQuery('.filter-count .post_count');
        const $practicesTaxonomyCount = jQuery('#practices-tab .counter');
        const $sectorsTaxonomyCount = jQuery('#sectors-tab .counter');
        const $globalNetworksTaxonomyCount = jQuery('#global_networks-tab .counter');

        // Expert tabs and mobile navigation
        const mobileWidth = 762;
        const $expertsTabsContainer = jQuery('.tabs');
        const $expertsTabContentContainer = jQuery('#experts-tab-content-container');
        const $listingAnchor = jQuery('#listing-anchor');
        const bannerSleeveHeight = jQuery('.banner-sleeve').outerHeight();
        const $contentWrapper = jQuery('.experts-listing--wrapper');
        const $mobileFilterToggle = jQuery('#filter-toggle');
        const $mobileFilterMenu = jQuery('#mobile-filter-menu');
        const $desktopFilterMenu = jQuery('.our-experts-tabs');
        const $restoreFilters = jQuery('#restore-toplevel-filters');
        const $mobileFilterBackButtonContainer = jQuery('.mobile-back-button');
        const $keywordTab = jQuery('#keyword-tab');
        const $practicesTab = jQuery('#practices-tab');
        const $sectorsTab = jQuery('#sectors-tab');
        const $networkTab = jQuery('#global_networks-tab');

        // State variables
        let isSearching = false;
        let sort = 'ASC';
        let rs = jQuery('#rs').val();
        let order_by = '';
        let termsHash = {
            practices: [],
            sectors: [],
            global_networks: []
        };

        /*************************************
         * TAXONOMY FILTER HELPERS
         *************************************/
        const setTaxonomySearch = function(taxonomy) {
            termsHash[taxonomy] = [];
            jQuery('[data-taxonomy="' + taxonomy + '"]').remove();
            jQuery('#' + taxonomy + '-panel input[type="checkbox"]:checked').each(function() {
                let termVal = parseInt(jQuery(this).val(), 10);
                termsHash[taxonomy].push(termVal);
                $filterSelections.append(
                    '<div class="taxonomy_term_filter" data-term_id="' +
                    termVal + '" data-taxonomy="' + taxonomy + '" role="button" tabindex="0" aria-pressed="false" aria-label="'+ BrunswickL10n.removeLabel + ' ' + jQuery(this).attr('data-term_value') + '">' +
                    jQuery(this).attr('data-term_value') + '</div>'
                );
            });
        };

        //accessibility keyboard navigation
        // once at init time
        /* Delegate from the container
        Put a single keydown on our parent and catch any .taxonomy_term_filter children. This way you never accidentally double‐attach, and it even handles filters added later */
        // somewhere in your init code, only once:
        $filterSelections
            .off('keydown.taxFilterNav')       // remove any prior namespaced binding
            .on(
            'keydown.taxFilterNav',    // namespaced event so off() only clears this
            '.taxonomy_term_filter',   // selector to delegate to
            function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                jQuery(this).click();
                }
            }
        );

        const setTaxonomyCounterState = function(taxonomy) {
            /*const count = jQuery('#' + taxonomy + '-panel input[type="checkbox"]:checked').length;
            if (count > 0) {
                jQuery('#' + taxonomy + '-tab .counter').show();
            } else {
                jQuery('#' + taxonomy + '-tab .counter').hide();
            }*/
        };

        const clearTaxonomyFilters = function() {
            jQuery('.tab-content input[type="checkbox"]').prop('checked', false)
                .removeClass('child-terms-selected child-terms-selected--all');
            termsHash.practices = [];
            termsHash.sectors = [];
            termsHash.global_networks = [];
            $filterSelections.empty();
            $practicesTaxonomyCount.hide();
            $sectorsTaxonomyCount.hide();
            $globalNetworksTaxonomyCount.hide();
        };

        /*const setTaxonomyFilterCount = function($taxonomyCountElm, taxonomyCounts, totalPostCount) {
            if (totalPostCount > 0 && taxonomyCounts > 0 ) {
                $taxonomyCountElm.html(taxonomyCounts);
                $taxonomyCountElm.show();
            }else {
                $taxonomyCountElm.html('');
                $taxonomyCountElm.hide();
            }
        };*/

        // Check if we should show/hide clear selection link.
        const setClearSelection = () => {
            let filterCount = jQuery( '.filter-selections .taxonomy_term_filter' ).length;
            if (filterCount > 0) {
                $clearSelectionsLink.show();
            } else {
                $clearSelectionsLink.hide();
            }
        };

        const setCheckboxState = function($checkboxElm, taxonomyUnusedTerms) {
            const checkboxId = $checkboxElm.attr('id');
            const termId = parseInt($checkboxElm.val(), 10);
            const unusedTerms = Object.values(taxonomyUnusedTerms);
            if (jQuery.inArray(termId, unusedTerms) !== -1) {
                $checkboxElm.prop('disabled', true);
                jQuery('label[for="' + checkboxId + '"]').addClass('disabled');
            } else {
                $checkboxElm.prop('disabled', false);
                jQuery('label[for="' + checkboxId + '"]').removeClass('disabled');
            }
        };

        /*************************************
         * AJAX SEARCH FUNCTIONALITY
         *************************************/
        const submitExpertSearch = function(pagenum= 1, closeTab = true) {
            $expertsList.css('height', $expertsList.height() + 'px');
            $ajaxLoader.show();
            $expertsList.css('opacity', 0);
            //disable the submit button
            $submitButton.prop('disabled', true);
            $submitButton.addClass('loading');
            let data = {
                action: 'expertsAjaxEvents',
                request: 'getExperts',
                keyword: $expertsSearchKeyword.val(),
                practices: termsHash.practices,
                sectors: termsHash.sectors,
                global_networks: termsHash.global_networks,
                pagenum: pagenum,
                sort: sort,
                order_by: order_by,
                rs: rs,
            };
            setQueryString(data);
            jQuery.ajax({
                url: BrunswickL10n.ajax_url,
                data: data,
                success: function(response) {
                    $expertsList.html(response.data.markup);
                    $pagination.html(response.data.markup_pagination);
                    let totalPostCount = response.data.post_count;
                    $postCount.html(
                        totalPostCount + '&nbsp;' +
                        (totalPostCount === 1 ? $postCount.attr('data-label-singular') : $postCount.attr('data-label-plural'))
                    );
                    //Hide/show elements based on post count
                    if(totalPostCount > 0){
                        $sortContainer.show();
                    }else {
                        $sortContainer.hide();
                    }
                    //setTaxonomyFilterCount($practicesTaxonomyCount, response.data.taxonomy_counts.practices, totalPostCount);
                    //setTaxonomyFilterCount($sectorsTaxonomyCount, response.data.taxonomy_counts.sectors, totalPostCount);
                    //setTaxonomyFilterCount($globalNetworksTaxonomyCount, response.data.taxonomy_counts.global_networks, totalPostCount);
                    $expertsFilterPractices.find('input[type="checkbox"]').each(function() {
                        setCheckboxState(jQuery(this), response.data.taxonomy_unused_terms.practices);
                    });
                    $expertsFilterSectors.find('input[type="checkbox"]').each(function() {
                        setCheckboxState(jQuery(this), response.data.taxonomy_unused_terms.sectors);
                    });
                    $expertsFilterGlobalNetworks.find('input[type="checkbox"]').each(function() {
                        setCheckboxState(jQuery(this), response.data.taxonomy_unused_terms.global_networks);
                    });
                },
                complete: function() {
                    let hideActions = false;
                    if (
                        data.keyword === '' &&
                        termsHash.practices.length === 0 &&
                        termsHash.sectors.length === 0 &&
                        termsHash.global_networks.length === 0
                    ) {
                        $postCount.hide();
                        hideActions = true;
                    } else {
                        $postCount.show();
                    }
                    setPagination();
                    isSearching = false;
                    $expertsList.css({ height: 'auto', opacity: 1 });
                    $ajaxLoader.hide();
                    //enable the submit button
                    $submitButton.prop('disabled', false);
                    $submitButton.removeClass('loading');
                    if(closeTab){
                        //also hide the actions, if the panel is not expanded
                        if(hideActions){
                            $actions.hide();
                        }
                        let $activeTab = jQuery('.our-experts-tabs [role="tab"][aria-selected="true"]');
                        if(	jQuery(window).width() <= mobileWidth) {
                            //check if the filter menu is open, close it
                            if ($mobileFilterToggle.attr('aria-expanded') === 'true') {
                                $mobileFilterToggle.click();
                                $activeTab = false;
                            }
                        }
                        if ($activeTab.length) {
                            $activeTab.click();
                        }
                    }
                    window.revealElements();
                }
            });
        };

        const setQueryString = function(data) {
            let querystring = '';
            //Setup querystring
            if (data.keyword) querystring += 'keyword=' + encodeURIComponent(data.keyword) + '&';
            ['practices', 'sectors', 'global_networks'].forEach(function(taxonomy) {
                if (data[taxonomy]) {
                    data[taxonomy].forEach(function(term) {
                        querystring += taxonomy + '[]=' + term + '&';
                    });
                }
            });
            if (data.sort) querystring += 'sort=' + encodeURIComponent(data.sort) + '&';
            if (data.order_by) querystring += 'order_by=' + encodeURIComponent(data.order_by) + '&';
            if (data.rs) querystring += 'rs=' + encodeURIComponent(data.rs) + '&';
            if (data.pagenum && data.pagenum > 1) querystring += 'pagenum=' + encodeURIComponent(data.pagenum) + '&';
            // Strip trailing &
            let qs = querystring.replace(/&$/, '');
            // Compute the new URL
            const newUrl = window.location.pathname + (qs ? `?${qs}` : '');
            // Save current scroll position into the current entry
            const scrollY = jQuery(window).scrollTop();
            history.replaceState(
                { id: 'expertsListing', scrollTop: scrollY },
                '',
                window.location.href
            );
            // Push the new URL as a fresh entry with scrollTop = 0
            history.pushState(
                { id: 'expertsListing', scrollTop: 0 },
                '',
                newUrl
            );
        };
        //Event listener for the scroll position state based due to modifying querystring
        window.addEventListener('popstate', e => {
            const y = e.state && e.state.scrollTop != null
                ? e.state.scrollTop
                : 0;
            window.scrollTo(0, y);
        });
        const setPagination = function() {
            $pagination.off('click').on('click', 'a.page-numbers', function(e) {
                e.preventDefault();
                if (isSearching) return false;
                isSearching = true;
                $searchFormSubmit[0].scrollIntoView();
                const pagenum = jQuery(this).text();
                submitExpertSearch(pagenum);
            });
        };

        /*************************************
         * TAXONOMY URL & INITIAL STATE
         *************************************/
        const setExpertsTaxonomy = function(taxonomy) {
            let terms = (new URL(location.href)).searchParams.getAll(taxonomy + '[]');
            if (terms && terms.length) {
                terms.forEach(function(term) {
                    termsHash[taxonomy].push(parseInt(term, 10));
                });
                jQuery('#' + taxonomy + '-panel input[type="checkbox"]:checked').each(function() {
                    $filterSelections.append(
                        '<div class="taxonomy_term_filter" data-term_id="' +
                        jQuery(this).val() + '" data-taxonomy="' + taxonomy + '" role="button" tabindex="0" aria-pressed="false" aria-label="'+ BrunswickL10n.removeLabel + ' ' + jQuery(this).attr('data-term_value') + '">' +
                        jQuery(this).attr('data-term_value') + '</div>'
                    );
                });
            }
        };

        /*************************************
         * EVENT HANDLERS SETUP
         *************************************/
        const setExpertsEventHandlers = function() {
            // Parent checkbox: toggle all child checkboxes
            $parentCheckbox.on('change', function() {
                const $this = jQuery(this);
                $this.removeClass('child-terms-selected');
                $this.closest('.parent-terms')
                    .find('.child-terms input[type="checkbox"]:enabled')
                    .prop('checked', $this.prop('checked'));
                $this.toggleClass('child-terms-selected--all', $this.prop('checked'));
            });

            // Child checkbox: update parent checkbox state
            $childrenCheckbox.on('change', function() {
                const $this = jQuery(this);
                const $parent = $this.closest('.parent-terms').find('.parent-term input[type="checkbox"]');
                const $childCheckboxes = $this.closest('.child-terms').find('input[type="checkbox"]');
                const $checkedChildren = $childCheckboxes.filter(':checked');
                $parent.prop('checked', false).removeClass('child-terms-selected--all');
                $parent.toggleClass('child-terms-selected', $checkedChildren.length > 0);
                if ($childCheckboxes.length === $checkedChildren.length) {
                    $parent.prop('checked', true)
                        .removeClass('child-terms-selected')
                        .addClass('child-terms-selected--all');
                }
            });

            // Click on taxonomy filter selection to remove it
            $filterSelections.on('click', '.taxonomy_term_filter', function(e) {
                e.preventDefault();
                if (isSearching) return false;
                isSearching = true;
                const $this = jQuery(this);
                const catId = parseInt($this.attr('data-term_id'), 10);
                const taxonomyType = $this.attr('data-taxonomy');
                if(taxonomyType==='keyword'){
                    $this.remove();
                    $expertsSearchKeyword.val('');
                }else{
                    const index = termsHash[taxonomyType].indexOf(catId);
                    if (index >= 0) {
                        termsHash[taxonomyType].splice(index, 1);
                        $this.remove();
                        let $checkboxElement = jQuery('input[type="checkbox"][value="' + catId + '"]');
                        $checkboxElement.prop('checked', false);
                        //If child term, check if parent checkbox should be adjusted
                        if($checkboxElement.closest('li').hasClass('child-term')){
                            let $parent = $checkboxElement.closest('.parent-terms').find('.parent-term input[type="checkbox"]');
                            let $checkedChildren = $checkboxElement.closest('.child-terms').find('input[type="checkbox"]:checked');
                            $parent.toggleClass('child-terms-selected', $checkedChildren.length > 0);
                        }
                    }
                    setTaxonomyCounterState(taxonomyType);
                }
                submitExpertSearch();
            });

            // Sorting
            $sortLink.on('click', function(e) {
                e.preventDefault();
                if (isSearching) return false;
                isSearching = true;
                sort = jQuery(this).attr('data-sort');
                order_by = 'name';
                $sortLink.removeClass('active');
                jQuery(this).addClass('active');
                submitExpertSearch();
            });

            // Reset filters
            $expertsListingContainer.on('click', '.reset-link',function(e) {
                e.preventDefault();
                if (isSearching) return false;
                isSearching = true;
                $expertsSearchKeyword.val('');
                clearTaxonomyFilters();
                sort = '';
                $sortLink.removeClass('active');
                jQuery('.tab-links .active').trigger('click');
                $actions.hide();
                $postCount.hide();
                submitExpertSearch();
            });

            // Clear filter selection for active tab only
            $clearSelectionsLink.on('click', function(e) {
                e.preventDefault();
                if (isSearching) return false;
                isSearching = true;
                const selectedTab = jQuery(this).attr('data-selectedtab');
                jQuery('#' + selectedTab + '-panel input[type="checkbox"]')
                    .prop('checked', false)
                    .removeClass('child-terms-selected child-terms-selected--all');
                jQuery('.filter-selections [data-taxonomy="' + selectedTab + '"]').remove();
                termsHash[selectedTab] = [];
                submitExpertSearch(1,false);
            });
        };

        /*************************************
         * TABS CALLBACK & INITIALIZATION
         *************************************/
        const expertTabs = document.querySelectorAll('.our-experts-tabs [role="tab"]');
        window.tabsCallback = function(selectedTab) {
            const tabType = selectedTab.dataset.tab;
            if (tabType === 'keyword') {
                $submitButton.html('Submit');
                $clearSelectionsLink.hide();
                $mobileFilterMenu.find('button.active').removeClass('active');
            } else {
                $submitButton.html('Apply');
                setClearSelection();
            }
            $submitButton.attr('data-selectedtab', tabType);
            $clearSelectionsLink.attr('data-selectedtab', tabType);
            if (expertTabs.length) {
                toggleExpertTabs(selectedTab);
            }
        };
        const setKeywordFilter = function() {
            let keyword = $expertsSearchKeyword.val();
            if(keyword !=='') {
                $filterSelections.append(
                    '<div class="taxonomy_term_filter" data-term_id="0" data-taxonomy="keyword" role="button" tabindex="0" aria-pressed="false" aria-label="' + BrunswickL10n.removeLabel + ' ' + $expertsSearchKeyword.val() + '">' +
                    $expertsSearchKeyword.val() + '</div>'
                );
            }
        }
        const initExperts = function() {
            setKeywordFilter();
            ['practices', 'sectors', 'global_networks'].forEach(setExpertsTaxonomy);
            setPagination();
            setExpertsEventHandlers();
        };
        /*************************************
         * FORM SUBMISSION HANDLER
         *************************************/
        $searchFormSubmit.on('submit', function(e) {
            e.preventDefault();
            if (isSearching) return false;
            isSearching = true;
            const selectedTab = $submitButton.attr('data-selectedtab');
            if (selectedTab === 'keyword') {
                clearTaxonomyFilters();
                setKeywordFilter();
            } else {
                setTaxonomySearch(selectedTab);
                setTaxonomyCounterState(selectedTab);
                setClearSelection();
            }
            submitExpertSearch();
        });

        initExperts();

        /*************************************
         * EXPERT TABS & MOBILE FILTER NAVIGATION
         *************************************/
        let $targetPanel, targetPanelID;
        const toggleExpertTabs = function(target) {
			targetPanelID = jQuery(target).attr('aria-controls');
			$targetPanel =  jQuery('#' + targetPanelID);
            if (target.getAttribute('aria-selected') === 'true') {
                $actions.show();
                $targetPanel.append($actions);
                $actions.removeClass('collapsed partial-collapsed')
                    .find('.filter-count').removeClass('hidden').end()
                    .find('.filter-selections').removeClass('hidden').end()
                    .find('.actions--clear').removeClass('hidden').end()
                    .find('.actions--submit').removeClass('hidden');
                const keywordSearchInput = $targetPanel.find('.keyword-search-field')[0];
                if (keywordSearchInput) {
                    setTimeout(function() {
                        keywordSearchInput.focus();
                    }, 300);
                    $actions.removeClass('collapsed').addClass('partial-collapsed');
                    $actions.find('.filter-count').addClass('hidden');
                    $actions.find('.filter-selections').addClass('hidden');
                    $actions.find('.actions--clear').addClass('hidden');
                    $actions.find('.actions--submit').removeClass('hidden');
                    //remove class fixed from the actions panel
                    $actions.removeClass('fixed');
                    //in mobile, add class inactive to filters
                    $mobileFilterToggle.addClass('inactive');
                } else {
                    $actions.addClass('fixed');
                }
                
                if ($contentWrapper.length) {
                    $contentWrapper.addClass('overlay-active');
                }
            } else {
                $actions.appendTo($expertsTabContentContainer);
                //const $filterCountEl = $actions.find('.filter-count');
                if ($postCount.css('display') === 'block' || $postCount.css('display') === 'inline') {
                    $actions.find('.filter-count').removeClass('hidden');
                    $actions.find('.filter-selections').removeClass('hidden');
                    $actions.find('.actions--clear').addClass('hidden');
                    $actions.find('.actions--submit').addClass('hidden');
                    $actions.addClass('partial-collapsed');
                    $actions.show();
                } else {
                    $actions.addClass('collapsed').removeClass('partial-collapsed');
                    $actions.hide();
                }
                if ($listingAnchor.length) {
                    const anchorTop = $listingAnchor.offset().top;
                    let offsetAdjustment;
                    if ($actions.css('display') === 'block') {
                        offsetAdjustment = anchorTop - $expertsTabsContainer.outerHeight() - bannerSleeveHeight - $actions.outerHeight();
                    } else {
                        offsetAdjustment = anchorTop - $expertsTabsContainer.outerHeight() - bannerSleeveHeight;
                    }
                    const anchorRectTop = $listingAnchor.offset().top - jQuery(window).scrollTop();
                    if (anchorRectTop < $expertsTabsContainer.outerHeight()) {
                        jQuery('html, body').animate({ scrollTop: offsetAdjustment }, 400);
                    }
                }
                if ($contentWrapper.length) {
                    if (!jQuery($mobileFilterMenu).hasClass('active')) {
                        $contentWrapper.removeClass('overlay-active').css({
                            height: '',
                            overflow: ''
                        });
                    }
                }
                $mobileFilterToggle.removeClass('inactive');
			}
			//in mobile view, if we clicked on the keyword search button
			//hide the mobile filters menu
			if(	jQuery(window).width() <= mobileWidth &&
				jQuery(target).attr('id') === $keywordTab.attr('id')) {
				//check if the filter menu is open, close it
				if($mobileFilterToggle.attr('aria-expanded') === 'true') {
                    $mobileFilterToggle.click();
                    $mobileFilterToggle.addClass('inactive');
				}
			}
			//show the back button
			//hide the tabs
			if (jQuery(window).width() <= mobileWidth) {
				if ($restoreFilters.attr('aria-expanded') === 'true') {
					$restoreFilters.attr('aria-expanded', 'false');
					$mobileFilterBackButtonContainer.prop('hidden', false);
					hideMobileFilterMenu($targetPanel);
					// Uncomment the line below if you need to adjust the margin-top of the targetPanel:
					// $targetPanel.css('margin-top', -$mobileFilterMenu.outerHeight() + 'px');
				}
			}
			

        }; //end toggleExpertTabs
        const moveExpertTabs = function() {
            if ($mobileFilterMenu.length && $desktopFilterMenu.length) {
                if (jQuery(window).width() <= mobileWidth) {
                    $mobileFilterMenu.append($practicesTab, $sectorsTab, $networkTab);
                } else {
                    $desktopFilterMenu.append($practicesTab, $sectorsTab, $networkTab);
                }
            }
        };
		//move on load
        moveExpertTabs();
        /*************************************
         * MOBILE FILTER NAVIGATION
         *************************************/

		//mobile filter toggle tab
		$mobileFilterToggle.on('click', function(e) {
			e.preventDefault();
			hideAllFilters();
			if (jQuery(this).attr('aria-expanded') === 'false') {
				if($keywordTab.attr('aria-selected') === 'true') {
					$keywordTab.click();
				}
				jQuery(this).attr('aria-expanded', 'true');
				jQuery(this).addClass('active');
				jQuery(this).removeClass('inactive');
				$mobileFilterMenu.addClass('active');
				$restoreFilters.attr('aria-expanded', 'true');
				$keywordTab.addClass('inactive');
				//add overlay
				if ($contentWrapper.length) {
					$contentWrapper.addClass('overlay-active');
				}
				
			} else {
				jQuery(this).attr('aria-expanded', 'false');
				jQuery(this).removeClass('active');
				$keywordTab.removeClass('inactive');
				$restoreFilters.attr('aria-expanded', 'false');
				$mobileFilterMenu.removeClass('active');
				//remove overlay, if keyword tab is not active
				if($keywordTab.attr('aria-selected') === 'false') {
					$contentWrapper.removeClass('overlay-active');
				}
			}
		});

		const hideAllFilters = function() {
            if ($mobileFilterBackButtonContainer.length) {
                $mobileFilterBackButtonContainer.prop('hidden', true);
            }
            const $activeButton = $mobileFilterMenu.find('button.active');
            if ($activeButton.length) {
                $activeButton.click();
            }
        };

		const hideMobileFilterMenu = function($targetPanel) {
			$mobileFilterMenu.removeClass('active');
			$mobileFilterBackButtonContainer.prop('hidden', false);
		}

		const showMobileFilterMenu = function() {
			$mobileFilterMenu.addClass('active');
			hideAllFilters();
		}

		//back button
		$restoreFilters.on('click', function() {
			if (jQuery(this).attr('aria-expanded') === 'false') {
				showMobileFilterMenu();
				jQuery(this).attr('aria-expanded', 'true');
			}
		});

		//in mobile, we also have expandable, collapsable parent categories
		//create click listeners for the buttons that control these areas
		const mobileTermToggles = document.querySelectorAll('.mobile-term-toggle');
		mobileTermToggles.forEach(mobileTermToggle => {
			mobileTermToggle.addEventListener('click', function() {
				if (this.getAttribute('aria-expanded') === 'false') {
					this.setAttribute('aria-expanded', 'true');
					this.classList.add('active');
					const controlledIds = this.getAttribute('aria-controls').split(/\s+/);
					controlledIds.forEach(id => {
						const targetElement = document.getElementById(id);
						if (targetElement) {
							targetElement.style.display = 'flex';
							targetElement.style.height = targetElement.scrollHeight + "px";
						}
					});
				} else {
					this.setAttribute('aria-expanded', 'false');
					this.classList.remove('active');
					const controlledIds = this.getAttribute('aria-controls').split(/\s+/);
					controlledIds.forEach(id => {
						const targetElement = document.getElementById(id);
						if (targetElement) {
							targetElement.style.display = 'none';
							targetElement.style.height = '0px';
						}
					});
				}
			});
		});
		/*************************************
		* RESIZE HANDLING
		*************************************/
        // Create a debounced version of moveExpertTabs
        const debouncedmoveExpertTabs = debounce(moveExpertTabs, 250);
        // Attach the handler to the resize event
        // Wrap the debounced function to pass a custom argument
        window.addEventListener('resize', () => {
            debouncedmoveExpertTabs();
        });
    } // End: if experts-filter-form exists
});
